<template>

<app-page :locked="is.moving">

	<app-page-head title="Categories" :count="list.length">

		<app-page-head-search v-model="searchText" :count="list.length" />

		<template v-if="$permission('full')">

			<app-page-head-action route="Category.Clone" icon="clone" tooltip="Clone category" />
			<app-page-head-action route="Category" :params="{ category: 'new' }" icon="create" tooltip="Add category" />
			<app-page-head-action v-if="$canDelete" v-on:click="onDeleteClick" :danger="true" :disabled="!selected.length" :count="selected.length" icon="delete" tooltip="Delete selected item(s)" />

		</template>

	</app-page-head>

	<app-page-content :is-loading="is.moving" :is-empty="!list.length" empty-message="No categories found." :can-reorder="($permission('edit')) ? order : false" v-on:reordered="onReordered">

		<com-item v-for="item in list" :key="item.id" :item="item" :highlight="searchText" :selected="isSelected(item.id)" v-on:shiftclick="onSelectClick(item.id)" />

	</app-page-content>

	<app-page-foot />

</app-page>

</template>

<script>

import mixList from '@/mixin/list'

export default {

	mixins: [mixList],

	components: {
		'com-item': () => import('./categories/Item')
	},

	data: function() {

		return {
			store: 'categories'
		}

	},

	methods: {

		search: function(value) {

			return this.$util.search(value.title, this.searchText) 

		}

	}

}

</script>

<style scoped>

</style>
